import createIcon from '@/lib/create-icon'

const ArrowRightIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 21 20' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.7129 9.66166C17.0058 9.95456 17.0058 10.4294 16.7129 10.7223L11.664 15.7713C11.3711 16.0642 10.8962 16.0642 10.6033 15.7713C10.3104 15.4784 10.3104 15.0035 10.6033 14.7106L14.372 10.942L4.40165 10.942C3.98743 10.942 3.65165 10.6062 3.65165 10.192C3.65165 9.77778 3.98743 9.44199 4.40165 9.44199L14.372 9.44199L10.6033 5.67334C10.3104 5.38044 10.3104 4.90557 10.6033 4.61267C10.8962 4.31978 11.3711 4.31978 11.664 4.61268L16.7129 9.66166Z'
      fill='currentColor'
    />
  </svg>,
  'ArrowRightIcon'
)

export default ArrowRightIcon
